import { ELEMENT_KEYS, MULTI_PAGE_SEPARATOR } from "./lib/constants";

const NODE_ENV = process.env.NODE_ENV;
const CRISP_WEBSITE_ID = process.env.REACT_APP_CRISP_WEBSITE_ID;

const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
const FIREBASE_MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

const config = {
  NODE_ENV,
  IS_DEV: NODE_ENV === "development",
  IS_PROD: NODE_ENV === "production",
  CRISP_WEBSITE_ID,
  FIREBASE: {
    FIREBASE_API_KEY,
    FIREBASE_APP_ID,
    FIREBASE_MEASUREMENT_ID,
  },
  appId: "GRID",
  appName: "Grid",
  // tagline: "Realtime Markdown-based Social Media Builder",
  tagline:
    "A free, real-time Markdown-powered builder for social posts — preview, paginate, and export in seconds.",
  sponser: "https://www.buymeacoffee.com/mehullakhanpal",
  MIXPANEL_TOKEN: process.env.REACT_APP_MIXPANEL_TOKEN,
};

const POST_VARIANTS = [
  {
    label: "Single-page",
    value: "default",
  },
  {
    label: "Multi-page",
    value: "multipage",
    description: `Break content into multiple pages using ${MULTI_PAGE_SEPARATOR} tag`,
  },
  {
    label: "Listicle",
    value: "listicle",
    description: `Content is broken into multiple pages on new line`,
  },
  // {
  //   label: "Cover",
  //   value: "cover",
  // },

  // {
  //   label: "Carousel",
  //   value: "carousel",
  // },
  // {
  //   label: "Video",
  //   value: "video",
  // },
];

const DEFAULT_LAYOUT_CONFIG = {
  [ELEMENT_KEYS.TITLE]: {
    key: ELEMENT_KEYS.TITLE,
    type: "textarea",
    rows: 6,
    order: 1,
    visible: true,
    variants: [],
    activeVariant: null,
  },
  [ELEMENT_KEYS.CONTENT]: {
    key: ELEMENT_KEYS.CONTENT,
    type: "textarea",
    rows: 20,
    order: 2,
    visible: true,
    variants: [],
    activeVariant: null,
  },
  [ELEMENT_KEYS.BRAND]: {
    key: ELEMENT_KEYS.BRAND,
    type: "input",
    order: 0,
    rows: 1,
    visible: true,
    variants: [],
    activeVariant: null,
  },
  [ELEMENT_KEYS.FILES]: {
    key: ELEMENT_KEYS.FILES,
    type: "file",
    order: 3,
    visible: true,
    variants: [],
    activeVariant: null,
  },
};

const ELEMENT_CONFIG = {
  table: {
    allowedProperties: [],
    hiddenProperties: [],
    tags: [".table-wrapper", "table", "tr", "td", "th"],
    customParsingElement: ".table-wrapper",
  },
};

export { POST_VARIANTS, DEFAULT_LAYOUT_CONFIG, ELEMENT_CONFIG };

export default config;
